import React, { Component } from 'react';
import config from 'react-global-configuration';
// Helpers de formulário
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class ToogleCheckedIncident extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      update: false,
      report_incident: this.props.report_incident,
      actual_checked: this.props.actual_checked,
    };

    this.locale = getLocale();
  }

  // Handlers
  handleToggleChange (name, event) {
    var change = {};
    var fatigue_event = this.state.report_incident.fatigue_event;
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.checkFadiga(change, fatigue_event);
  }

  checkFadiga(change, fatigue_event) {
    if (window.confirm(this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.marcarEsteIncidenteComoChecado)) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      var url = '/fadiga/voluntaria/arquivar/' + this.state.report_incident.id;
      var requisition_method = 'PUT';
      if (fatigue_event !== 5) {
        var url = '/relatorio-de-fadiga/tripulante/checkar/' + this.state.report_incident.id;
        var requisition_method = 'GET';
      }
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + url, { method: requisition_method, mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState(change);
            self.props.updateReports();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === false && typeof newProps.report_incident !== 'undefined')){
      this.setState({
        actual_checked: newProps.actual_checked,
        report_incident: newProps.report_incident,
        loaded: true,
        update: false,
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <Toggle
          checked={this.state.actual_checked}
          aria-label='No label tag'
          name="actual_checked"
          disabled={this.state.actual_checked == true ? true : false}
          onChange={this.handleToggleChange.bind(this, 'actual_checked')}
        />
      </div>
    );
  }
}

export default ToogleCheckedIncident;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/Elements/ToogleCheckedIncident.js